import React, { useEffect, useState } from "react";
import Resizer from "react-image-file-resizer";
import $ from "jquery";
import { InputBase, styled } from "@mui/material";
import * as exifr from 'exifr';
import { Link } from "react-router-dom";

export const ROLE = {
  ALL   : {code : "ALL" , desc : "Login required"},
  SA    : {code : "SA"  , desc : "SA"},
  CS    : {code : "CS"  , desc : "CS"},
  AD    : {code : "AD"  , desc : "AD"},
  WK    : {code : "WK"  , desc : "WK"},
  MO    : {code : "MO"  , desc : "MO"}
};

export function filterMenuByPermission(menu, allowedIds) {
  const filteredChildren = (menu.children || [])
    .map(child => filterMenuByPermission(child, allowedIds))
    .filter(Boolean)
    .sort((a, b) => a.id - b.id); // null 제거

  if (allowedIds.has(menu.id) || filteredChildren.length > 0) {
    return {
      ...menu,
      children: filteredChildren,
    };
  }

  return null;
}

export const fileAccepts = [
    {code : "M", titleKey : "message.common.file.accept.video", extension : ".mp4"},
    {code : "I", titleKey : "message.common.file.accept.picture", extension : ".jpg,.jpeg,.png,.gif"},
    {code : "P", titleKey : "message.common.file.accept.pdf", extension : ".pdf"},
    {code : "E", titleKey : "message.common.file.accept.etc", extension : ".hwp,.hwpx,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.zip"},
];

export const importantYns = [
  {code: "Y", titleKey:"message.common.select.main.management"},
  {code: "N", titleKey:"message.common.select.maintenance"}
];

export const useTitle = () => {
  const [title, setTitle] = useState("");
  const updateTitle = () => {
    if (title) {
      const htmlTitle = document.querySelector("title");
      htmlTitle.innerHTML = title;
    }
  };
  useEffect(updateTitle, [title]);

  return setTitle;
}

export const getBrowserTitle = (hostname) => {
  const titleMap = {
    'nt.metapredic.cn': 'header.title.nt',
    'wtsys.metapredic.cn': 'header.title.wt',
    'yihai.metapredic.cn': 'header.title.yh',
    'bk.safewalks.kr': 'header.title.bk',
    'cmms.safewalks.kr': 'header.title',
  };

  const title = titleMap[hostname] || 'header.title';
  // console.log(title)
  return title;
}

export function replaceString(value, replaceStr='_') {
  if (value) {
    let modValue = value.replaceAll(' ',replaceStr);
    return modValue;
  }
  return "";
}

export function extensionCheck(fileName, acceptCode) {
  const extension = fileName.substring(fileName.lastIndexOf("."));
  const accept = fileAccepts.filter(item => item.code === acceptCode);
  const accepts = (accept[0].extension.toLowerCase()).split(",");
  return (accepts[0] === '' || accepts.includes(extension.toLowerCase()));
}


export function getExtension(fileName) {
  const extension = fileName.substring(fileName.lastIndexOf(".")).trim();
  // console.log(extension)
  return extension.toLowerCase();
}

export const getDiagnosisGradeColor = (grade) => {
  if (grade) {
    if (grade === 'A') {
      return "circle1";
    } else if (grade === 'B') {
      return "circle2";
    } else if (grade === 'C') {
      return "circle3";
    } else if (grade === 'D') {
      return "circle4";
    }
  }
  return "";
}

export function getLowestRank({ rank_shaft, rank_horizon, rank_vertical } = {}) {
  const rankOrder = { A: 1, B: 2, C: 3, D : 4 };

  if (!rank_shaft || !rank_horizon || !rank_vertical) {
    return null; // 또는 'A' 같은 기본값
  }

  return [rank_shaft, rank_horizon, rank_vertical]
    .reduce((lowest, cur) =>
      rankOrder[cur] > rankOrder[lowest] ? cur : lowest
    );
}

// export const equipmentFaultGrade = [
//   {
//     code: "EG_AB",
//     title: "A/B",
//     items:["O7_N","O9_G"],
//     color : "#2d83b4"
//   },
//   {
//     code: "EG_CD",
//     title: "C/D",
//     items:["O1_F","O5_D"],
//     color : "#2d83b4"
//     // color : "#e6202e"
//   }
//   // {
//   //   code: "EG_AB",
//   //   title: "A/B",
//   //   items:["O7_N","O9_G"],
//   //   color : "#2d83b4"
//   // },
//   // {
//   //   code: "EG_CD",
//   //   title: "C/D",
//   //   items:["O1_F","O5_D"],
//   //   color : "#2d83b4"
//   //   // color : "#e6202e"
//   // }
// ];

export function getTemperatureColor(temp) {
  if (temp) {
    if (temp >= 45) {
      return "font_red"
    } else if (temp > 40 && temp < 45) {
      return "font_yellow"
    } else if (temp <= 40) {
      return "font_green"
    }
  }
  return "font_green";
}

// export const equipmentFaultStatusColors = [
//     {
//       code : "O1_F",
//       title : "bad",
//       color : "#2d83b4"
//       // color : "#e6202e"
//     },
//     {
//       code : "O2_M",
//       title : "error",
//       color : "#f16634"
//       // color : "#f0f002"
//     },
//     {
//       code : "O5_D",
//       title : "insuff",
//       color : "#2d83b4"
//       // color : "#f0f002"
//     },
//     {
//       code : "O6_C",
//       title : "communi",
//       color : "#f0f0f0"
//       // color : "#b2b2b2"
//     },
//     {
//       code : "O7_N",
//       title : "normal",
//       color : "#2d83b4"
//       // color : "#2672f7"
//     },
//     {
//       code : "O9_G",
//       title : "fine",
//       color : "#2d83b4"
//       // color : "#02db02"
//     },
// ];

export const equipmentFaultStatusColors = [
  {
    code : "O1_N",
    color : "#02db02",
    fontColor : '#fff'
  },
  {
    code : "O2_I",
    color : "#f0f002",
    fontColor : '#000'
  },
  {
    code : "O3_A",
    color : "#FF8A34",
    fontColor : '#fff'
  },
  {
    code : "O4_C",
    color : "#b2b2b2",
    fontColor : '#fff'
  }
];

export function orderString(list, property) {
  if (list && list.length > 0) {
    list.sort(function(a,b) {
      let upperCaseA = "";
      let upperCaseB = "";
      if (property) {
        upperCaseA = a[property].toUpperCase();
        upperCaseB = b[property].toUpperCase();
      } else {
        upperCaseA = a.toUpperCase();
        upperCaseB = b.toUpperCase();
      }
      if (upperCaseA > upperCaseB) return 1;
      if (upperCaseA < upperCaseB) return -1;
      if (upperCaseA === upperCaseB) return 0;
    });
  }
}

export function reverseOrderString(list, property) {
  if (list && list.length > 0) {
    list.sort(function(a,b) {
      let upperCaseA = "";
      let upperCaseB = "";
      if (property) {
        upperCaseA = a[property].toUpperCase();
        upperCaseB = b[property].toUpperCase();
      } else {
        upperCaseA = a.toUpperCase();
        upperCaseB = b.toUpperCase();
      }
      if (upperCaseA > upperCaseB) return -1;
      if (upperCaseA < upperCaseB) return 1;
      if (upperCaseA === upperCaseB) return 0;
    });
  }
}

export function orderNumber(list, property) {
  if (list && list.length > 0) {
    list.sort(function(a,b) {
      let upperCaseA = "";
      let upperCaseB = "";
      if (property) {
        upperCaseA = a[property];
        upperCaseB = b[property];
      } else {
        upperCaseA = a;
        upperCaseB = b;
      }
      if (upperCaseA > upperCaseB) return 1;
      if (upperCaseA < upperCaseB) return -1;
      if (upperCaseA === upperCaseB) return 0;
    });
  }
}

export function reverseOrderNumber(list, property) {
  if (list && list.length > 0) {
    list.sort(function(a,b) {
      let upperCaseA = "";
      let upperCaseB = "";
      if (property) {
        upperCaseA = a[property];
        upperCaseB = b[property];
      } else {
        upperCaseA = a;
        upperCaseB = b;
      }
      if (upperCaseA > upperCaseB) return -1;
      if (upperCaseA < upperCaseB) return 1;
      if (upperCaseA === upperCaseB) return 0;
    });
  }
}

export function numberComma(number) {
  if (number)
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  return null;
}

export function afileListFunc() {
  const $tableDiv = $("#tableDiv");
  const $fileDiv = $tableDiv.find("div.fileListDiv");
  let $fileElement = [];
  for(var i=0;i<$fileDiv.length;i++){
    $fileElement[i] = $("#"+$fileDiv[i].id);
    $fileElement[i].css('display','none');
    $fileElement[i].css('zIndex',0);
  }
  let $aTag = [];
  const $fileATag = $tableDiv.find("a.file_ATag");
  for(var k=0;k<$fileATag.length;k++){
    $aTag[k] = $("#"+$fileATag[k].id);

    $aTag[k].mouseover(function() {
      let aTagId = this.id;
      let divNum = aTagId.replaceAll("fileATag", '');
      let $divElement = $("#fileList"+divNum);
      for(var j=0;j<$fileElement.length;j++){
        $fileElement[j].css('display','none');
        $fileElement[j].css('zIndex',0);
      }

      try {
        $divElement.css('display','block');
        $divElement.css('zIndex',1);
      }catch(Exception) {}
    });

    $aTag[k].focus(function(){
      let aTagId = this.id;
      let divNum = aTagId.replaceAll("fileATag", '');
      let $divElement = $("#fileList"+divNum);

      for(var l=0;l<$fileElement.length;l++){
        $fileElement[l].css('display','none');
        $fileElement[l].css('zIndex',0);
      }

      try {
        $divElement.css('display','block');
        $divElement.css('zIndex',1);
      }catch(Exception) {}
    });
  }
}

export const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '8px 26px 8px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}));

export const periodSearchSelectItems = [
  {
    code : 0,
    titleKey : "message.common.select.current.year"
  },
  {
    code : 1,
    titleKey : "message.common.select.current.year.first.quarter"
  },
  {
    code : 2,
    titleKey : "message.common.select.current.year.second.quarter"
  },
  {
    code : 3,
    titleKey : "message.common.select.current.year.third.quarter"
  },
  {
    code : 4,
    titleKey : "message.common.select.current.year.fourth.quarter"
  },
  {
    code : 5,
    titleKey : "message.common.select.last.year"
  },
  {
    code : 6,
    titleKey : "message.common.select.last.year.first.quarter"
  },
  {
    code : 7,
    titleKey : "message.common.select.last.year.second.quarter"
  },
  {
    code : 8,
    titleKey : "message.common.select.last.year.third.quarter"
  },
  {
    code : 9,
    titleKey : "message.common.select.last.year.fourth.quarter"
  },
];

export const formatNumber = (num) =>
    new Intl.NumberFormat().format(num);

export function formatHourToText(hours, t) {
    if (!hours && hours !== 0) return '-';

    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);

    if (months >= 1) {
        return formatNumber(months)+t('message.common.text.month');
    }

    if (days >= 1) {
        return formatNumber(days)+t('message.common.text.day');
    }

    return formatNumber(hours)+t('message.common.text.time');
}

// export function getGradeAxial(data, addStr='') {
// 	if (data) {
// 		// if (data["axial"+addStr] === 'X') {
// 		// 	return data["gradeX"+addStr];
// 		// } else if (data["axial"+addStr] === 'Y') {
// 		// 	return data["gradeY"+addStr];
// 		// } else if (data["axial"+addStr] === 'Z') {
// 		// 	return data["gradeZ"+addStr];
// 		// }
//     return data["gradeX"+addStr];
// 	}
// 	return '-';
// }

// export function getGradeRadial(data, addStr='') {
// 	if (data) {
// 		// if (data["radial"+addStr] === 'X') {
// 		// 	return data["gradeX"+addStr];
// 		// } else if (data["radial"+addStr] === 'Y') {
// 		// 	return data["gradeY"+addStr];
// 		// } else if (data["radial"+addStr] === 'Z') {
// 		// 	return data["gradeZ"+addStr];
// 		// }
//     return data["gradeY"+addStr];
// 	}
// 	return '-';
// }

// export function getGradeVertical(data, addStr='') {
// 	if (data) {
// 		// if (data["vertical"+addStr] === 'X') {
// 		// 	return data["gradeX"+addStr];
// 		// } else if (data["vertical"+addStr] === 'Y') {
// 		// 	return data["gradeY"+addStr];
// 		// } else if (data["vertical"+addStr] === 'Z') {
// 		// 	return data["gradeZ"+addStr];
// 		// }
//     return data["gradeZ"+addStr];
// 	}
// 	return '-';
// }


// export function getOverallAxial(data, addStr='') {
// 	if (data) {
// 		// if (data["axial"+addStr] === 'X') {
// 		// 	return data["overallShaft"+addStr];
// 		// } else if (data["axial"+addStr] === 'Y') {
// 		// 	return data["overallHorizon"+addStr];
// 		// } else if (data["axial"+addStr] === 'Z') {
// 		// 	return data["overallVertical"+addStr];
// 		// }
//     return data["overallShaft"+addStr];
// 	}
// 	return 0;
// }

// export function getOverallRadial(data, addStr='') {
// 	if (data) {
// 		// if (data["radial"+addStr] === 'X') {
// 		// 	return data["overallShaft"+addStr];
// 		// } else if (data["radial"+addStr] === 'Y') {
// 		// 	return data["overallHorizon"+addStr];
// 		// } else if (data["radial"+addStr] === 'Z') {
// 		// 	return data["overallVertical"+addStr];
// 		// }
//     return data["overallHorizon"+addStr];
// 	}
// 	return 0;
// }

// export function getOverallVertical(data, addStr='') {
// 	if (data) {
// 		// if (data["vertical"+addStr] === 'X') {
// 		// 	return data["overallShaft"+addStr];
// 		// } else if (data["vertical"+addStr] === 'Y') {
// 		// 	return data["overallHorizon"+addStr];
// 		// } else if (data["vertical"+addStr] === 'Z') {
// 		// 	return data["overallVertical"+addStr];
// 		// }
//     return data["overallVertical"+addStr];
// 	}
// 	return 0;
// }

/**
 * 진동량 상태판정기준
 * @param {*} score 
 * @returns 
 */
export function getVibrationRatingStatusByScore(grade) {
  if (grade) {
    if (grade === 'A') {
      return "message.common.text.good"
    } else if (grade === 'B') {
      return "message.common.text.commonly"
    } else if (grade === 'C') {
      return "message.common.text.inadequate"
    } else if (grade === 'D') {
      return "message.common.text.error"
    }
  }
  return null;
}

/**
 * 신율 상태판정기준
 * @param {*} score 
 * @returns 
 */
export function getVBeltElongStatusByScore(score) {
  if (score || score === 0) {
    if (score < 1.5) {
      return "message.common.text.good"
    } else if (score >= 1.5 && score < 2.0) {
      return "message.common.text.commonly"
    } else if (score >= 2.0 && score < 2.5) {
      return "message.common.text.inadequate"
    } else if (score >= 2.5 && score < 4.0) {
      return "message.common.text.error"
    }
  }
  return null;
}

/**
 * 신율 상태판정기준
 * @param {*} score 
 * @returns 
 */
export function getVBeltElongStatusGradeByScore(score) {
  if (score || score === 0) {
    if (score < 1.5) {
      return "A"
    } else if (score >= 1.5 && score < 2.0) {
      return "B"
    } else if (score >= 2.0 && score < 2.5) {
      return "C"
    } else if (score >= 2.5 && score < 4.0) {
      return "D"
    }
  }
  return null;
}

/**
 * v-belt 길이 상태판정기준
 * @param {*} score 
 * @returns 
 */
export function getVBeltLengthStatusByScore(score) {
  if (score || score === 0) {
    if (score > 90) {
      return "message.common.text.good"
    } else if (score >= 85 && score < 90) {
      return "message.common.text.commonly"
    } else if (score >= 80 && score < 85) {
      return "message.common.text.inadequate"
    } else if (score < 80) {
      return "message.common.text.error"
    }
  }
  return null;
}


/**
 * v-belt 길이 상태판정기준
 * @param {*} score 
 * @returns 
 */
export function getVBeltLengthStatusGradeByScore(score) {
  if (score || score === 0) {
    if (score > 90) {
      return "A"
    } else if (score >= 85 && score < 90) {
      return "B"
    } else if (score >= 80 && score < 85) {
      return "C"
    } else if (score < 80) {
      return "D"
    }
  }
  return null;
}

/**
 * 동력전달율 상태판정기준
 * @param {*} score 
 * @returns 
 */
export function getVBeltEfficiencyStatusByScore(score) {
  if (score || score === 0) {
    if (score > 90) {
      return "message.common.text.good"
    } else if (score >= 85 && score < 90) {
      return "message.common.text.commonly"
    } else if (score >= 80 && score < 85) {
      return "message.common.text.inadequate"
    } else if (score < 80) {
      return "message.common.text.error"
    }
  }
  return null;
}

/**
 * 동력전달율 상태판정기준
 * @param {*} score 
 * @returns 
 */
export function getVBeltEfficiencyStatusGradeByScore(score) {
  if (score || score === 0) {
    if (score > 90) {
      return "A"
    } else if (score >= 85 && score < 90) {
      return "B"
    } else if (score >= 80 && score < 85) {
      return "C"
    } else if (score < 80) {
      return "D"
    }
  }
  return null;
}

export function getColorClassNameByGrade(grade) {
  if (grade) {
    if (grade === 'A') {
      return " ble_font"
    } else if (grade === 'B') {
      return " gre_font"
    } else if (grade === 'C') {
      return " yel_font"
    } else if (grade === 'D') {
      return " ju_font"
    }
    return ""
  }
}

export function getEquipmentCtgrImageNameByCodeOfDashboard(code3) {
  if (code3) {
    if (code3.startsWith('DBERAIL.')) {
      return 'overhead_s.gif';
    } else if (code3 === 'DIRECT.2') {
      return 'ahu_direct2_active.gif';
    } else if (code3 === 'EWDLG') {
      return 'EWDLG_OPEN.gif';
    } else if (code3 === 'ECRG') {
      return 'ECRG_OPEN.gif';
    } else if (code3 === 'ISMG.1') {
      return 'cmx_ismg1_active.png';
    } else if (code3 === 'ISMG.2') {
      return 'im_smg2_active.gif';
    } else if (code3 === 'ISMG.3') {
      return 'cmx_ismg3_active.png';
    } else if (code3 === 'ELECTRIC.1') {
      return 'imm_electric1_active.png';
    } else if (code3 === 'ELECTRIC.2') {
      return 'imm_electric2_active.png';
    } else if (code3 === 'R02MM.1') {
      return 'omx_r02mm1_active.png';
    } else if (code3 === 'R02MM.2') {
      return 'omx_r02mm2_active.png';
    } else if (code3.startsWith('DOUBLE.') || code3.startsWith('SINGLE.')) {
      return 'escalator.gif';
    // } else if (code3.startsWith('GEARED.') || code3.startsWith('GEARLESS.')) {
    //   return 'elevator.gif';
    } else if (code3.startsWith('DIRECT.') || code3.startsWith('PULLY.')) {
      return 'fan_start.gif';
    } else if (code3.startsWith('ESP.')) {
      return 'pump_start.gif';
    } else if (code3.startsWith('HBP.1')) {
      return 'vul_hbp1_active.png';
    } else if (code3.startsWith('STKCSGMAST.1') || code3.startsWith('DoubleMast')) {
      return 'hst_stkcsgmast1_active.png';
    // } else if (code3.startsWith('DOUBLE.') || code3.startsWith('SINGLE.') || code3.startsWith('GEARED.') || code3.startsWith('GEARLESS.')
    //   || code3.startsWith('DIRECT.') || code3.startsWith('PULLY.') || code3.startsWith('ESP.')) {
    //   return 'noimage.png';
    }
  }
  return 'noimage.gif'
}

/**
 * 공통 대시보드 및 일반설비상세
 * @param {*} code3 
 * @param {*} opStatus 
 * @param {*} opStatusDetail 
 * @param {*} doorStatus 
 * @param {*} type 
 * @returns 
 */
export function getEquipmentCtgrImageNameByCodeOfDashboardSub(code3, opStatus, opStatusDetail, doorStatus=null, type='dashboard') {
  if (code3) {
    if (code3 === 'DBERAIL.3') {
      if (opStatus && opStatus === 'ACTIVE' && opStatusDetail) {
        if (type === 'dashboard') {
          if (opStatusDetail === 'STOP')
            return 'overhead_s.gif';
          else if (opStatusDetail === 'UP')
            return 'overhead_u.gif';
          else if (opStatusDetail === 'DOWN')
            return 'overhead_d.gif';
          else if (opStatusDetail === 'FORWARD')
            return 'overhead_f.gif';
          else if (opStatusDetail === 'BACKWARD')
            return 'overhead_b.gif';
          else if (opStatusDetail === 'LEFT')
            return 'overhead_l.gif';
          else if (opStatusDetail === 'RIGHT')
            return 'overhead_r.gif';
          else
            return 'overhead_s.gif';
        } else {
          return '3d_arrow(m).glb';
        }
      }
      return 'overhead_s.gif';
    } else if (code3.startsWith('DBERAIL.')) {
      if (opStatus && opStatus === 'ACTIVE' && opStatusDetail) {
        if (opStatusDetail === 'STOP')
          return 'overhead_s.gif';
        else if (opStatusDetail === 'UP')
          return 'overhead_u.gif';
        else if (opStatusDetail === 'DOWN')
          return 'overhead_d.gif';
        else if (opStatusDetail === 'FORWARD')
          return 'overhead_f.gif';
        else if (opStatusDetail === 'BACKWARD')
          return 'overhead_b.gif';
        else if (opStatusDetail === 'LEFT')
          return 'overhead_l.gif';
        else if (opStatusDetail === 'RIGHT')
          return 'overhead_r.gif';
        else
          return 'overhead_s.gif';
      }
      return 'overhead_s.gif';
    } else if (code3 === 'DIRECT.2') {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'ahu_direct2_active.gif';
      } else {
        return 'ahu_direct2_stop.gif';
      }
      // return 'ahu_direct2_stop.gif';
    } else if (code3 === 'EWDLG') {
      if (opStatus && opStatus === 'ACTIVE' && doorStatus) {
        if (doorStatus === 'DOOR_CLOSED' || doorStatus === 'DOOR_CLOSING')
          return 'EWDLG_CLOSE.gif';
        else if (doorStatus === 'DOOR_OPEN' || doorStatus === 'DOOR_OPENING')
          return 'EWDLG_OPEN.gif';
        else
          return 'EWDLG_STOP.gif';
      }
      return 'EWDLG_STOP.gif';
    } else if (code3 === 'ECRG') {
      if (opStatus && opStatus === 'ACTIVE' && doorStatus) {
        if (doorStatus === 'DOOR_CLOSED' || doorStatus === 'DOOR_CLOSING')
          return 'ECRG_CLOSE.gif';
        else if (doorStatus === 'DOOR_OPEN' || doorStatus === 'DOOR_OPENING')
          return 'ECRG_OPEN.gif';
        else
          return 'ECRG_STOP.gif';
      }
      return 'ECRG_STOP.gif';
    } else if (code3 === 'ISMG.1') {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'cmx_ismg1_active.png';
      } else {
        return 'cmx_ismg1_stop.png';
      }
    } else if (code3 === 'ISMG.2') {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'im_smg2_active.gif';
      } else {
        return 'im_smg2_stop.gif';
      }
    } else if (code3 === 'ISMG.3') {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'cmx_ismg3_active.png';
      } else {
        return 'cmx_ismg3_stop.png';
      }
    } else if (code3 === 'ELECTRIC.1') {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'imm_electric1_active.png';
      } else {
        return 'imm_electric1_stop.png';
      }
    } else if (code3 === 'ELECTRIC.2') {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'imm_electric2_active.png';
      } else {
        return 'imm_electric2_stop.png';
      }
    } else if (code3 === 'R02MM.1') {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'omx_r02mm1_active.png';
      } else {
        return 'omx_r02mm1_stop.png';
      }
    } else if (code3 === 'R02MM.2') {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'omx_r02mm2_active.png';
      } else {
        return 'omx_r02mm2_stop.png';
      }
    } else if (code3.startsWith('DOUBLE.') || code3.startsWith('SINGLE.')) {
      if (opStatus && opStatus === 'ACTIVE') {
        if (opStatusDetail && opStatusDetail === 'DOWN')
          return 'escalator_down.gif';
        else if (opStatusDetail && opStatusDetail === 'STOP')
          return 'escalator_stop.gif';
        else if (opStatusDetail && opStatusDetail === 'UP')
          return 'escalator_up.gif';
        else
          return 'escalator.gif';
      }
      // if (type === 'dashboard') {
      //   return 'escalator.gif';
      // } else {
        return 'escalator_stop.gif';
      // }
    } else if (code3.startsWith('GEARED.') || code3.startsWith('GEARLESS.')) {
      if (opStatus && opStatus === 'ACTIVE') {
        if (opStatusDetail && opStatusDetail === 'DOWN')
          return 'elevator_down.gif';
        else if (opStatusDetail && opStatusDetail === 'UP')
          return 'elevator_up.gif';
        else if (opStatusDetail && opStatusDetail === 'STOP') {
          if (doorStatus && (doorStatus === 'DOOR_CLOSED' || doorStatus === 'DOOR_CLOSING'))
            return 'elevator_close.gif';
          else if (doorStatus && (doorStatus === 'DOOR_OPEN' || doorStatus === 'DOOR_OPENING'))
            return 'elevator_open.gif';
          else 
            return 'elevator_close.gif';
        } else
          return 'elevator.gif';
      }
      // if (type === 'dashboard')
      //   return 'elevator.gif';
      // else
        return 'elevator_close.gif';
    } else if (code3.startsWith('DIRECT.') || code3.startsWith('PULLY.')) {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'fan_start.gif';
      } else {
        return 'fan_stop.gif';
      }
    } else if (code3.startsWith('ESP.')) {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'pump_start.gif';
      } else {
        return 'pump_stop.gif';
      }
    } else if (code3.startsWith('HBP.1')) {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'vul_hbp1_active.png';
      } else {
        return 'vul_hbp1_stop.png';
      }
    } else if (code3.startsWith('STKCSGMAST.1') || code3.startsWith('DoubleMast')) {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'hst_stkcsgmast1_active.png';
      } else {
        return 'hst_stkcsgmast1_stop.png';
      }
    // } else if (code3.startsWith('DOUBLE.') || code3.startsWith('SINGLE.') || code3.startsWith('GEARED.') || code3.startsWith('GEARLESS.')
    //   || code3.startsWith('DIRECT.') || code3.startsWith('PULLY.') || code3.startsWith('ESP.')) {
    //   return 'noimage.png';
    }
  }
  if (type === 'dashboard')
    return 'noimage.gif'
  else
    return 'sample.png'
}

/**
 * 설비상세 iot 타입
 * @param {*} code3 
 * @param {*} opStatus 
 * @param {*} opStatusDetail 
 * @param {*} doorStatus 
 * @param {*} type 
 * @returns 
 */
export function getEquipmentCtgrImageNameByCodeOfDashboardSubMp4(code3, opStatus, opStatusDetail, doorStatus=null, type='dashboard') {
  if (code3) {
    if (code3 === 'DBERAIL.3') {
        return '3d_arrow(m).glb';

      // if (opStatus && opStatus === 'ACTIVE' && opStatusDetail) {
      //   return '3d_arrow(m).glb';
      //   // if (opStatusDetail === 'STOP')
      //   //   return 'overhead_s.gif';
      //   // else if (opStatusDetail === 'UP')
      //   //   return 'overhead_u.gif';
      //   // else if (opStatusDetail === 'DOWN')
      //   //   return 'overhead_d.gif';
      //   // else if (opStatusDetail === 'FORWARD')
      //   //   return 'overhead_f.gif';
      //   // else if (opStatusDetail === 'BACKWARD')
      //   //   return 'overhead_b.gif';
      //   // else if (opStatusDetail === 'LEFT')
      //   //   return 'overhead_l.gif';
      //   // else if (opStatusDetail === 'RIGHT')
      //   //   return 'overhead_r.gif';
      //   // else
      //   //   return 'overhead_s.gif';
      // }
      // return 'overhead_s.gif';
    } else if (code3.startsWith('DBERAIL.')) {
      if (opStatus && opStatus === 'ACTIVE' && opStatusDetail) {
        if (opStatusDetail === 'STOP')
          return 'overhead_s.gif';
        else if (opStatusDetail === 'UP')
          return 'overhead_u.gif';
        else if (opStatusDetail === 'DOWN')
          return 'overhead_d.gif';
        else if (opStatusDetail === 'FORWARD')
          return 'overhead_f.gif';
        else if (opStatusDetail === 'BACKWARD')
          return 'overhead_b.gif';
        else if (opStatusDetail === 'LEFT')
          return 'overhead_l.gif';
        else if (opStatusDetail === 'RIGHT')
          return 'overhead_r.gif';
        else
          return 'overhead_s.gif';
      }
      return 'overhead_s.gif';
    } else if (code3 === 'DIRECT.2') {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'ahu_direct2_active.gif';
      } else {
        return 'ahu_direct2_stop.gif';
      }
      // return 'ahu_direct2_stop.gif';
    } else if (code3 === 'EWDLG') {
      if (opStatus && opStatus === 'ACTIVE' && doorStatus) {
        if (doorStatus === 'DOOR_CLOSED' || doorStatus === 'DOOR_CLOSING')
          return 'EWDLG_CLOSE.gif';
        else if (doorStatus === 'DOOR_OPEN' || doorStatus === 'DOOR_OPENING')
          return 'EWDLG_OPEN.gif';
        else
          return 'EWDLG_STOP.gif';
      }
      return 'EWDLG_STOP.gif';
    } else if (code3 === 'ECRG') {
      if (opStatus && opStatus === 'ACTIVE' && doorStatus) {
        if (doorStatus === 'DOOR_CLOSED' || doorStatus === 'DOOR_CLOSING')
          return 'ECRG_CLOSE.gif';
        else if (doorStatus === 'DOOR_OPEN' || doorStatus === 'DOOR_OPENING')
          return 'ECRG_OPEN.gif';
        else
          return 'ECRG_STOP.gif';
      }
      return 'ECRG_STOP.gif';
    } else if (code3 === 'ISMG.1') {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'cmx_ismg1_active.png';
      } else {
        return 'cmx_ismg1_stop.png';
      }
    } else if (code3 === 'ISMG.2') {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'im_smg2_active.gif';
      } else {
        return 'im_smg2_stop.gif';
      }
    } else if (code3 === 'ISMG.3') {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'cmx_ismg3_active.png';
      } else {
        return 'cmx_ismg3_stop.png';
      }
    } else if (code3 === 'ELECTRIC.1') {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'imm_electric1_active.png';
      } else {
        return 'imm_electric1_stop.png';
      }
    } else if (code3 === 'ELECTRIC.2') {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'imm_electric2_active.png';
      } else {
        return 'imm_electric2_stop.png';
      }
    } else if (code3 === 'R02MM.1') {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'omx_r02mm1_active.png';
      } else {
        return 'omx_r02mm1_stop.png';
      }
    } else if (code3 === 'R02MM.2') {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'omx_r02mm2_active.png';
      } else {
        return 'omx_r02mm2_stop.png';
      }
    } else if (code3.startsWith('DOUBLE.') || code3.startsWith('SINGLE.')) {
      if (opStatus && opStatus === 'ACTIVE') {
        if (opStatusDetail && opStatusDetail === 'DOWN')
          return 'escalator_down.mp4';
        else if (opStatusDetail && opStatusDetail === 'STOP')
          return 'escalator_stop.mp4';
        else if (opStatusDetail && opStatusDetail === 'UP')
          return 'escalator_up.mp4';
        else
          return 'escalator_up.mp4';
      }

      // if (type === 'dashboard') {
      //   return 'escalator_stop.mp4';
      // } else {
        return 'escalator_stop.mp4';
      // }
    } else if (code3.startsWith('GEARED.') || code3.startsWith('GEARLESS.')) {
      if (opStatus && opStatus === 'ACTIVE') {
        if (opStatusDetail && opStatusDetail === 'DOWN')
          return 'elevator_down.gif';
        else if (opStatusDetail && opStatusDetail === 'UP')
          return 'elevator_up.gif';
        else if (opStatusDetail && opStatusDetail === 'STOP') {
          if (doorStatus && (doorStatus === 'DOOR_CLOSED' || doorStatus === 'DOOR_CLOSING'))
            return 'elevator_close.gif';
          else if (doorStatus && (doorStatus === 'DOOR_OPEN' || doorStatus === 'DOOR_OPENING'))
            return 'elevator_open.gif';
          else 
            return 'elevator_close.gif';
        } else
          return 'elevator.gif';
      }
      // if (type === 'dashboard')
      //   return 'elevator.gif';
      // else
        return 'elevator_close.gif';
    } else if (code3.startsWith('DIRECT.') || code3.startsWith('PULLY.')) {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'fan_active.mp4';
      } else {
        return 'fan_stop.mp4';
      }
    } else if (code3.startsWith('ESP.')) {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'pump_start.mp4';
      } else {
        return 'pump_stop.mp4';
      }
    } else if (code3.startsWith('HBP.1')) {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'vul_hbp1_active.png';
      } else {
        return 'vul_hbp1_stop.png';
      }
    } else if (code3.startsWith('STKCSGMAST.1') || code3.startsWith('DoubleMast')) {
      if (opStatus && opStatus === 'ACTIVE') {
        return 'hst_stkcsgmast1_active.png';
      } else {
        return 'hst_stkcsgmast1_stop.png';
      }
    // } else if (code3.startsWith('DOUBLE.') || code3.startsWith('SINGLE.') || code3.startsWith('GEARED.') || code3.startsWith('GEARLESS.')
    //   || code3.startsWith('DIRECT.') || code3.startsWith('PULLY.') || code3.startsWith('ESP.')) {
    //   return 'noimage.png';
    }
  }
  if (type === 'dashboard')
    return 'noimage.gif'
  else
    return 'sample.png'
}

// export function getEquipmentCtgrImageNameByCodeOfDashboardNantong(code) {
//   if (code) {
//     if (code === 'ES') {
//       return 'escalator_stop.mp4';
//     // } else if (code === 'EV') {
//     //   return 'elevator.gif';
//     } else if (code === 'AHU') {
//       return 'fan_stop.mp4';
//     } else if (code === 'PUMP') {
//       return 'pump_stop.mp4';
//     }
//   }
//   return 'noimage.mp4'
// }

export function getEquipmentCtgrImageNameByCodeOfDashboardSubNantongMp4(code, opStatus, opStatusDetail, doorStatus=null, type='dashboard') {
  if (code) {
    if (code === 'ES') {
      if (opStatus === 'ACTIVE') {
        if (opStatusDetail && opStatusDetail === 'DOWN')
          return 'escalator_down.mp4';
        else if (opStatusDetail && opStatusDetail === 'STOP')
          return 'escalator_stop.mp4';
        else if (opStatusDetail && opStatusDetail === 'UP')
          return 'escalator_up.mp4';
        else
          return 'escalator_up.mp4';
      }
      // if (type === 'dashboard') {
      //   return 'escalator_stop.mp4';
      // } else {
        return 'escalator_stop.mp4';
      // }
    } else if (code === 'EV') {
      if (opStatus === 'ACTIVE') {
        if (opStatusDetail && opStatusDetail === 'DOWN')
          return 'elevator_down.gif';
        else if (opStatusDetail && opStatusDetail === 'UP')
          return 'elevator_up.gif';
        else if (opStatusDetail && opStatusDetail === 'STOP') {
          if (doorStatus && (doorStatus === 'DOOR_CLOSED' || doorStatus === 'DOOR_CLOSING'))
            return 'elevator_close.gif';
          else if (doorStatus && (doorStatus === 'DOOR_OPEN' || doorStatus === 'DOOR_OPENING'))
            return 'elevator_open.gif';
          else 
            return 'elevator_close.gif';
        } else 
          return 'elevator.gif';
      }
      // if (type === 'dashboard')
      //   return 'elevator.gif';
      // else
        return 'elevator_close.gif';
    } else if (code === 'AHU') {
      if (opStatus === 'ACTIVE')
        return 'fan_active.mp4';
      else
        return 'fan_stop.mp4';
    } else if (code === 'PUMP') {
      if (opStatus === 'ACTIVE')
        return 'pump_start.mp4';
      else
        return 'pump_stop.mp4';
    } else if (code === 'VUL') {
      if (opStatus === 'ACTIVE')
        return 'vul_hbp1_active.png';
      else
        return 'vul_hbp1_stop.png';
    } else if (code === 'HST') {
      if (opStatus === 'ACTIVE')
        return 'hst_stkcsgmast1_active.png';
      else
        return 'hst_stkcsgmast1_stop.png';
    }
  }
  return 'noimage.mp4'
}

export function getEquipmentCtgrImageNameByCodeOfDashboardNantong(code) {
  if (code) {
    if (code === 'ES') {
      return 'escalator.gif';
    } else if (code === 'EV') {
      return 'elevator.gif';
    } else if (code === 'AHU') {
      return 'fan_start.gif';
    } else if (code === 'PUMP') {
      return 'pump_start.gif';
    } else if (code === 'VUL') {
      return 'vul_hbp1_active.png';
    } else if (code === 'HST') {
      return 'hst_stkcsgmast1_active.png';
    }
  }
  return 'noimage.gif'
}

export function getEquipmentCtgrImageNameByCodeOfDashboardSubNantong(code, opStatus, opStatusDetail, doorStatus=null, type='dashboard') {
  if (code) {
    if (code === 'ES') {
      if (opStatus === 'ACTIVE') {
        if (opStatusDetail && opStatusDetail === 'DOWN')
          return 'escalator_down.gif';
        else if (opStatusDetail && opStatusDetail === 'STOP')
          return 'escalator_stop.gif';
        else if (opStatusDetail && opStatusDetail === 'UP')
          return 'escalator_up.gif';
        else
          return 'escalator.gif';
      }
      // if (type === 'dashboard') {
      //   return 'escalator.gif';
      // } else {
        return 'escalator_stop.gif';
      // }
    } else if (code === 'EV') {
      if (opStatus === 'ACTIVE') {
        if (opStatusDetail && opStatusDetail === 'DOWN')
          return 'elevator_down.gif';
        else if (opStatusDetail && opStatusDetail === 'UP')
          return 'elevator_up.gif';
        else if (opStatusDetail && opStatusDetail === 'STOP') {
          if (doorStatus && (doorStatus === 'DOOR_CLOSED' || doorStatus === 'DOOR_CLOSING'))
            return 'elevator_close.gif';
          else if (doorStatus && (doorStatus === 'DOOR_OPEN' || doorStatus === 'DOOR_OPENING'))
            return 'elevator_open.gif';
          else 
            return 'elevator_close.gif';
        } else 
          return 'elevator.gif';
      }
      // if (type === 'dashboard')
      //   return 'elevator.gif';
      // else
        return 'elevator_close.gif';
    } else if (code === 'AHU') {
      if (opStatus === 'ACTIVE')
        return 'fan_start.gif';
      else {
        if (type === 'dashboard')
          return 'fan_start.gif';
        else
          return 'fan_stop.gif';
      }
    } else if (code === 'PUMP') {
      if (opStatus === 'ACTIVE')
        return 'pump_start.gif';
      else {
        if (type === 'dashboard')
          return 'pump_start.gif';
        else
          return 'pump_stop.gif';
      }
    } else if (code === 'VUL') {
      if (opStatus === 'ACTIVE')
        return 'vul_hbp1_active.png';
      else {
        if (type === 'dashboard')
          return 'vul_hbp1_active.gif';
        else
          return 'vul_hbp1_stop.png';
      }
    } else if (code === 'HST') {
      if (opStatus === 'ACTIVE')
        return 'hst_stkcsgmast1_active.png';
      else {
        if (type === 'dashboard')
          return 'hst_stkcsgmast1_active.gif';
        else
          return 'hst_stkcsgmast1_stop.png';
      }
    }
  }
  return 'noimage.gif'
}

export const equipmentISOStatus = [
  {
    code: "A",
    title: "A",
    color : "font_green",
    color2 : "#02db02",
    color3 : "#62b929",
    fontColor : "#fff"
  },
  {
    code: "B",
    title: "B",
    color : "font_blue",
    color2 : "#2672f7",
    color3 : "#2672f7",
    fontColor : "#fff"
  },
  {
    code: "C",
    title: "C",
    color : "font_yellow",
    color2 : "#f0f002",
    color3 : "#f0f002",
    fontColor : "#000"
  },
  {
    code: "D",
    title: "D",
    color : "font_red",
    color2 : "#ed1c24",
    color3 : "#ed1c24",
    fontColor : "#fff"
  }
];

/**
 * 배터리 잔량 표현 이미지
 * @param {*} batLevel 
 * @returns 
 */
export function getBatLevelImgByBatLevel(batLevelData) {
  if (batLevelData === 0 || batLevelData) {
    let batLevel = batLevelData.toFixed(0);
    if (batLevel < 10) {
      return "bat_0-10.png"
    } else if (batLevel >= 10 && batLevel < 20) {
      return "bat_10-20.png"
    } else if (batLevel >= 20 && batLevel < 40) {
      return "bat_20-40.png"
    } else if (batLevel >= 40 && batLevel < 60) {
      return "bat_40-60.png"
    } else if (batLevel >= 60 && batLevel < 80) {
      return "bat_60-80.png"
    } else if (batLevel >= 80 && batLevel < 90) {
      return "bat_80-90.png"
    } else if (batLevel >= 90) {
      return "bat_90-100.png"
    }
  }
  return null;
}

/**
 * 사업자등록번호 유효성 검사
 * @param {string} bizNo - 사업자등록번호 (예: "220-81-62517" 또는 "2208162517")
 * @returns {boolean} 유효하면 true, 아니면 false
 */
export function isValidBizNo(bizNo) {
  // 하이픈 제거
  const number = bizNo.replace(/-/g, '');

  // 숫자 10자리 아니면 false
  if (!/^\d{10}$/.test(number)) return false;

  const digits = number.split('').map(d => parseInt(d, 10));
  const weights = [1, 3, 7, 1, 3, 7, 1, 3, 5];

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    const calc = digits[i] * weights[i];
    sum += calc;
    if (i === 8) sum += Math.floor(calc / 10); // 9번째 자리의 몫 추가
  }

  const checkDigit = (10 - (sum % 10)) % 10;
  return checkDigit === digits[9];
}

export function truncate(str, maxLength = 10) {
  return str.length > maxLength ? str.slice(0, maxLength) + "..." : str;
}

export const getFontSize = (text) => {
    if (!text) return 24;
// console.log(text.length)
    if (text.length <= 6) return 24;
    if (text.length <= 10) return 20;
    if (text.length <= 15) return 16;

    return 14;
};

export const getSettledValue = (result, defaultValue = null) =>
  result.status === 'fulfilled'
    ? result.value
    : defaultValue;

export function fileChangedHandler(event, maxWith, maxHeight, responseUriFunc, alertMessage, setAlertMessage, handleAlertClick) {
  const file = event.target?.files?.[0];
  if (file) {
    try {
      if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) {
        // console.log("Unsupported file type:", file.type);
        handleAlertClick("Unsupported file type: "+ file.type);
        responseUriFunc('')
        return;
      }

      Resizer.imageFileResizer(file, maxWith, maxHeight, "JPEG", 90, 0, responseUriFunc, "file", 0, 0)
    } catch (err) {
      console.log(err)
      handleAlertClick(err.message);
      responseUriFunc('')
    }
  }
}

// VR 인지 일반이미지인지 판별 시작
const VR_RATIO = 2;
const VR_RATIO_TOLERANCE = 0.03; // 엄격하게 체크
const MIN_WIDTH = 2000; // 너무 작은 이미지는 제외

// 2:1 비율 체크
export const isEquirectangular = (width, height) => {
  const ratio = width / height;
  return Math.abs(ratio - VR_RATIO) < VR_RATIO_TOLERANCE;
  // return Math.abs(ratio - 2.0) < 0.05;
};

export const checkImageFromBlob = async (blob) => {
  // 1. URL 생성
  const url = URL.createObjectURL(blob);

  // 2. XMP 메타데이터 확인
  let meta = {};
  try {
    // XMP 메타데이터는 대부분 jpg/webp 에 존재
    if (
      blob.type === 'image/jpeg' ||
      blob.type === 'image/webp'
    ) {
      meta = await exifr.parse(blob, {
        xmp: true
      });
    }
  } catch (e) {
    console.warn('XMP 읽기 실패', e);
  }

  const xmpCheck =
    meta?.UsePanoramaViewer === true ||
    meta?.GPano?.UsePanoramaViewer === true;

  // 3. 이미지 비율 확인
  const img = new Image();

  return new Promise((resolve) => {
    img.onload = () => {
      // const ratioCheck = isEquirectangular(img.width, img.height);
      // resolve({ url, is360: xmpCheck || ratioCheck, width: img.width, height: img.height });
      const width = img.width;
      const height = img.height;

      // 2:1 비율 확인
      const ratioCheck = isEquirectangular(width, height);

      // 너무 작은 이미지는 VR 제외
      // const sizeCheck = width >= MIN_WIDTH;

      const is360 =
        xmpCheck ||
        (ratioCheck);
        // (ratioCheck && sizeCheck);

      // 메모리 해제
      // URL.revokeObjectURL(url);

      resolve({
        url,
        is360,
        width,
        height,
        ratio: width / height,
        xmpCheck,
        ratioCheck,
        // sizeCheck
      });
    };
    
    img.onerror = () => {
      URL.revokeObjectURL(url);

      resolve({
        url: null,
        is360: false
      });
    };

    img.src = url;
  });
};

export const checkVrFileByFileUrl = async(fileUrl) => {
  try {
    console.log(fileUrl)
    const response = await fetch(fileUrl); // 실제 API 주소로 변경
    if (!response.ok) {
      throw new Error('file download fail');
    }

    const blob = await response.blob();
    // JPG + PNG 허용
    const allowedTypes = [
      'image/jpeg',
      'image/png',
      'image/webp'
    ];
    if (!allowedTypes.includes(blob.type)) {
      throw new Error('Unsupported image format');
    }

    if (blob) {
      // const { url, is360 } = await checkImageFromBlob(blob);
      // const result = {url : url, is360 : is360}
      // return result;
      return await checkImageFromBlob(blob);
    } else {
      throw('not')
    }
  } catch (error) {
    console.error('image file download fail:', error);
    return {
      url: null,
      is360: false
    };
  }
};

export const fetchImageBlob = async (url) => {
  const blobCache = new Map();
  if (blobCache.has(url)) return blobCache.get(url);

  const response = await fetch(url);
  const blob = await response.blob();
  blobCache.set(url, blob);
  return blob;
};
// VR 인지 일반이미지인지 판별 끝

export const markerColorByStatus = {
  // 'O1_N': process.env.PUBLIC_URL+'/img/icon/pin-blue.png',
  // 'O2_I': process.env.PUBLIC_URL+'/img/icon/pin-orange.png',
  // 'O3_A': process.env.PUBLIC_URL+'/img/icon/pin-red.png',
  // 'unmapped': process.env.PUBLIC_URL+'/img/icon/pin-grey.png'
  'O1_N': process.env.PUBLIC_URL+'/markers/green.svg',
  'O2_I': process.env.PUBLIC_URL+'/markers/yellow.svg',
  'O3_A': process.env.PUBLIC_URL+'/markers/orange.svg',
  'unmapped': process.env.PUBLIC_URL+'/markers/grey.svg'
};

// export const colorByEquipmentFaultStatus = {
//   // 'O1_N': process.env.PUBLIC_URL+'/img/icon/pin-blue.png',
//   // 'O2_I': process.env.PUBLIC_URL+'/img/icon/pin-orange.png',
//   // 'O3_A': process.env.PUBLIC_URL+'/img/icon/pin-red.png',
//   // 'unmapped': process.env.PUBLIC_URL+'/img/icon/pin-grey.png'
//   'O1_N': 'blue',
//   'O2_I': 'orange',
//   'O3_A': 'red',
//   'unmapped': 'grey'
// };

export function parseListByString(str, separator=',') {
  return str
    .replace(/^\[|\]$/g, "") // 맨 앞 뒤 대괄호 제거
    .split(separator)              // 콤마로 split
    .filter(Boolean);        // 빈 값 제거 (예: [] 케이스)
}

export const safeParse = (str) => {
  if (!str) return null;
  try {
    return JSON.parse(str);
  } catch {
    return null;
  }
}

export const getEquipmentStatusColor = (countO1N, countO2I, countO3A, countO4C) => {
  // const maxCount = Math.max(countO1N, countO2I, countO3A, countO4C);
  // if (countO3A === maxCount) {
  //   return {bg:"#E53935",marker:"red"};
  // } else if (countO2I === maxCount) {
  //   return {bg:"#ff8c4b",marker:"orange"};
  // } else if (countO1N === maxCount) {
  //   return {bg:"#2672f7",marker:"blue"};
  // } else {
  //   return {bg:"#dddddd",marker:"grey"};
  // }
  if (countO3A > 0) {
    return {bg:"#FF8A34",marker:"orange"};
  } else if (countO2I > 0) {
    return {bg:"#f0f002",marker:"yellow"};
  } else if (countO1N > 0) {
    return {bg:"#02db02",marker:"green"};
  } else {
    return {bg:"#b2b2b2",marker:"grey"};
  }
}


export const getEquipmentAlertColor = (countO1N, countO2I, countO3A, countO4C) => {
  if (countO3A > 0) {
    return 'circle_O3_A';
  // } else if (countO2I > 0) {
  //   return 'circle_O2_I';
  } else {
    return '';
  }
}

export const getEquipmentStatusColorByStatus = (status) => {
  if (status === 'O3_A') {
    return {bg:"#FF8A34", bg2:"#FF8A34",color:"#fff", stroke:"#a55a25", className:'font_orange', className2:'condition1'};
  } else if (status === 'O2_I') {
    return {bg:"#f0f002", bg2:"#f0f002",color:"#000", stroke:"#b3b304", className:'font_yellow', className2:'condition2'};
  } else if (status === 'O1_N') {
    return {bg:"#02db02", bg2:"#62b929",color:"#fff", stroke:"#047e04", className:'font_green', className2:'condition6'};
  } else {
    return {bg:"#b2b2b2", bg2:"#b2b2b2",color:"#000", stroke:"#000", className:'font_gray', className2:'condition7'};
  }
}

export const getEquipmentStatusColorByStatusOrCommunicationIssue = (status, hasCommunicationIssue) => {
  if (hasCommunicationIssue) {
    return {bg:"#777",color:"#fff", stroke:"#414040", className:''};
  } else {
    return getEquipmentStatusColorByStatus(status);
  }
}

export const getEquipmentChipColorByType = (logCode) => {
  if (logCode === 'CO2' || logCode === 'PM10' || logCode === 'PM25' || logCode === 'DP' || logCode === 'HCHO' || logCode === 'TVOC') {  // 공기질
    return 'in_orange'
  } else if (logCode === 'RH' || logCode === 'RH_SPT' || logCode === 'RH_ST') { // 습도
    if (logCode === 'RH_SPT') {
      return 'in_blue in_blue_b'
    } else if (logCode === 'RH_ST') {
      return 'in_blue in_blue_w'
    }
    return 'in_blue'
  } else if (logCode === 'T' || logCode === 'T_SPT' || logCode === 'T_ST') {  // 온도
    if (logCode === 'T_SPT') {
      return 'in_green in_green_b'
    } else if (logCode === 'T_ST') {
      return 'in_green in_green_w'
    }
    return 'in_green'
  } else if (logCode === 'POS' || logCode === 'POS_SPT' || logCode === 'SP' || logCode === 'STATIC' || logCode === 'STATIC_SPT') { // AHU
    return 'in_purple'
  } else if (logCode === 'ENA' || logCode === 'ST' || logCode === 'SW') { // SYS
    return 'navi'
  } else {
    return 'in_gray'
  }
}

export const uniqueByEquipmentPartCode = (arr, limit) => {
  const seen = new Set();
  if (limit)
    return arr
      .filter(item => {
        if (seen.has(item.equipmentPartCode)) return false;
        seen.add(item.equipmentPartCode);
        return true;
      })
      .slice(0, limit); // ✅ n개만 남김
  else
    return arr
      .filter(item => {
        if (seen.has(item.equipmentPartCode)) return false;
        seen.add(item.equipmentPartCode);
        return true;
      })
};

export const uniqueByEquipmentPartIdAndLogCode = (arr, limit) => {
  const seen = new Set();
  if (limit)
    return arr
      .filter(item => {
        const key = `${item.equipmentPartId}_${item.logCode}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      })
      .slice(0, limit); // ✅ n개만 남김
  else
    return arr
      .filter(item => {
        const key = `${item.equipmentPartId}_${item.logCode}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      })
};

export function getControlPannelTitle(controlLog) {
  if (controlLog.componentLocationCode === 'NONE') {
      return controlLog.equipmentPartName + ' ' + controlLog.logName
  } else {
      return controlLog.componentLocationName + ' ' + controlLog.equipmentPartName + ' ' + controlLog.logName
  }
}

export const groupByComponentLocationCode = (arr) => {
  const map = new Map();

  arr.forEach(item => {
    const key = item.componentLocationCode;
    if (!map.has(key)) {
      map.set(key, []);
    }
    map.get(key).push(item);
  });

  return [...map.entries()].map(([componentLocationCode, items]) => ({
    componentLocationCode,
    items,
  }));
};

const getByPath = (obj, path) =>
  path.split(".").reduce((acc, key) => acc?.[key], obj);

export const groupAndDeduplicate = (arr, {
    groupBy = ['componentLocationCode'],
    dedupeBy = [],
  }
  ) => {
  const seen = new Set();           // 중복 체크용
  const groupMap = new Map();       // 그룹화용

  for (const item of arr) {
    // ✅ 중복 제거 키 (dot-path 대응)
    const dedupeKey = dedupeBy
      .map(path => getByPath(item, path))
      .join("||");

    if (dedupeKey && seen.has(dedupeKey)) continue;
    if (dedupeKey) seen.add(dedupeKey);

    // ✅ 그룹화 키 (dot-path 대응)
    const groupKey = groupBy
      .map(path => getByPath(item, path))
      .join("||") || "__ALL__";

    if (!groupMap.has(groupKey)) {
      groupMap.set(groupKey, {
        group: Object.fromEntries(
          groupBy.map(path => [
            path,
            getByPath(item, path),
          ])
        ),
        items: [],
      });
    }

    groupMap.get(groupKey).items.push(item);
  }

  return [...groupMap.values()];
};

export function getLogValueDescByCodeAndValue(type, code, value, equipmentPartCode, componentLocationCode) {
  if (type == null || code == null || value == null) {
    return { kind: "text", value: "-" };
  }

  if (code === 'ENA') {
    if (type === 'icon') { // 아이콘 표시
      if (equipmentPartCode === 'HUMID') {  // 가습기
        return {
          kind: "icon",
          value:
            value === "1" ? "water_drop_r" : "water_drop_b",
        };
      } else if (equipmentPartCode === 'DVM' || equipmentPartCode === 'DVM2') {  // 실외기
        return {
          kind: "icon",
          value:
            value === "1" ? "hvac_r" : "hvac_b",
        };
      } else if (componentLocationCode === 'RF1X1') {  // 환기팬
        return {
          kind: "icon",
          value:
            value === "1" ? "ventilationfan_r" : "ventilationfan_b",
        };
      } else if (componentLocationCode === 'SA' || componentLocationCode === 'SF1X2') {  // 급기, 급기팬
        return {
          kind: "icon",
          value:
            value === "1" ? "supplyfan_r" : "supplyfan_b",
        };
      } else {
        return {
          kind: "text",
          value:
            value === "1"
              ? "message.common.text.disable"
              : "message.common.text.use",
        };
      }
    } else {  // 텍스트표시
      return {
        kind: "text",
        value:
          value === "1"
            ? "message.common.text.disable"
            : "message.common.text.use",
      };
    }
  } else if (code === 'AL') {
    return {
      kind: "text",
      value:
        !Number.isNaN(Number(value)) ?
          (value === "1"
            ? "message.common.title.alarm"
            : "message.common.normal")
          : value
    };
  } else if (code === 'ST') {
    if (type === 'icon') { // 아이콘 표시
      if (equipmentPartCode === 'HUMID') {  // 가습기
        return {
          kind: "icon",
          value:
            value === "1" ? "water_drop_b" : "water_drop_r",
        };
      } else if (equipmentPartCode === 'DVM' || equipmentPartCode === 'DVM2') {  // 실외기
        return {
          kind: "icon",
          value:
            value === "1" ? "hvac_b" : "hvac_r",
        };
      } else if (componentLocationCode === 'RF1X1') {  // 환기팬
        return {
          kind: "icon",
          value:
            value === "1" ? "ventilationfan_b" : "ventilationfan_r",
        };
      } else if (componentLocationCode === 'SA' || componentLocationCode === 'SF1X2') {  // 급기, 급기팬
        return {
          kind: "icon",
          value:
            value === "1" ? "supplyfan_b" : "supplyfan_r",
        };
      } else {
        return {
          kind: "text",
          value:
            value === "1"
              ? "message.common.text.active"
              : "message.common.text.stop",
        };
      }
    } else {  // 텍스트표시
      return {
        kind: "text",
        value:
          value === "1"
            ? "message.common.text.active"
            : "message.common.text.stop",
      };
    }
  } else if (code === 'SW') {
    return {
      kind: "text",
      value:
        value === "1"
          ? "message.common.text.filter.pressure.differential"
          : "message.common.normal",
    };
  }
  return {
      kind: "text",
      value
  };
}

export function translateCommentLanguage(str, t, separator = ' > ') {
  if (!str) return str;

  return str
    .split('>')
    .map(key => t(key.trim()))
    .join(separator);
}

export function truncateText(text, maxLength = 8) {
  if (typeof text !== 'string') return text;

  return text.length > maxLength
    ? text.slice(0, maxLength) + '...'
    : text;
}

export function getPrivateIP() {
    return new Promise((resolve) => {
        const rtc = new RTCPeerConnection({ iceServers: [] });

        rtc.createDataChannel("");

        let resolved = false;

        rtc.createOffer()
            .then((offer) => rtc.setLocalDescription(offer))
            .catch(() => {
                resolved = true;
                resolve("UNKNOWN_PRIVATE");
            });

        rtc.onicecandidate = (event) => {
            if (resolved) return;

            const candidate = event?.candidate?.candidate;
            if (!candidate) return;

            const match = candidate.match(
                /([0-9]{1,3}(\.[0-9]{1,3}){3})/
            );

            if (match) {
                resolved = true;
                rtc.close();
                resolve(match[1]);
            }
        };

        setTimeout(() => {
            if (resolved) return;

            resolved = true;
            rtc.close();
            resolve("UNKNOWN_PRIVATE");
        }, 1000);
    });
}

export const makeFaultsMessage = (alert, getEnumValueByEnumNameAndCode, isMovieView=false, playMovie) => {
  switch (alert.alertCategory) {
    case "IOT_FD":
      return alert.equipmentPartFaultCodes && alert.equipmentPartFaultCodes.length > 0 ?
        alert.equipmentPartFaultCodes.map(function(codes, idx) {
          return (
      <div key={idx} style={{display:"flex", alignItems:"center"}}>
          {codes.equipmentPart?.componentLocation?.name} - {codes.equipmentPart?.masterEquipmentPart?.name} : 
          {codes.diagnosisCode?.subCategoryNm}({codes.diagnosisCode?.categoryNm})
          {isMovieView && <>&nbsp;<span className="icon_png" style={{verticalAlign:"middle", cursor:"pointer"}} onClick={()=>{playMovie(codes.diagnosisCode?.code)}}>
            <img src={`${process.env.PUBLIC_URL}/img/icon/emergency_recording.png`} alt='' />
          </span></>}
      </div> 
          )
        })
      : ""
  
    case "IOT_VK":
      return alert.equipmentPartVibrationRatings && alert.equipmentPartVibrationRatings.length > 0 ?
        alert.equipmentPartVibrationRatings.map(function(codes, idx) {
          return (
      <div key={idx} style={{display:"flex", alignItems:"center"}}>
          {codes.equipmentPart?.componentLocation?.name} - {codes.equipmentPart?.masterEquipmentPart?.name} : 
          {codes.rank}
      </div> 
          )
        })
      : ""
  
    case "IOT_MNG":
      if (alert.iotDeviceDeadHistories?.length > 0) {
        const iotDeviceDeadHistories = groupAndDeduplicate(alert.iotDeviceDeadHistories, {groupBy : ["device"], dedupeBy: []})
        if (iotDeviceDeadHistories) {
          return iotDeviceDeadHistories.map((iotMng, idx) => {
            if (iotMng.group.device === 'SENSOR') {
              return (
                <div key={idx} style={{display:"flex", alignItems:"center"}}>{getEnumValueByEnumNameAndCode("AlertDevice",iotMng.group.device)?.[0]?.title+" : "}
                {iotMng.items.map((item, idx2)=>{
                  return (
                    <React.Fragment key={idx2}>
                    {idx2 > 0 && <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                    {item.sn} ({item.sensorPosition?.equipmentPart?.componentLocation?.name} - {item.sensorPosition?.equipmentPart?.masterEquipmentPart?.name})<br/>
                    </React.Fragment>
                  )
                })}
                </div>
              )
            }
            if (iotMng.group.device === 'GATEWAY') {
              return (
                <div key={idx} style={{display:"flex", alignItems:"center"}}>{getEnumValueByEnumNameAndCode("AlertDevice",iotMng.group.device)?.[0]?.title+" : "}
                {iotMng.items.map((item, idx2)=>{
                  return (
                    <React.Fragment key={idx2}>
                    {idx2 > 0 && <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                    {item.sn}
                    </React.Fragment>
                  )
                })}
                </div>
              )
            }
          })
        } else {
          return "";
        }
      } else {
        return "";
      }
    default:
      return "";
  }
}

export const makeFaultsMessage2 = (alert, getEnumValueByEnumNameAndCode, newLine = '<br/>') => {
  let alertDtl = '';
  switch (alert.alertCategory) {
    case "IOT_FD":
      if (alert.equipmentPartFaultCodes && alert.equipmentPartFaultCodes.length > 0) {
          alertDtl += (alert.alertDtl ? newLine : "");
          alert.equipmentPartFaultCodes.map(function(codes, idx) {
              alertDtl += codes.equipmentPart?.componentLocation?.name+' - '+codes.equipmentPart?.masterEquipmentPart?.name+' : ';
              alertDtl += codes.diagnosisCode?.subCategoryNm+'('+codes.diagnosisCode?.categoryNm+')'+newLine;
          })
      }
      return alertDtl;
  
    case "IOT_VK":
      if (alert.equipmentPartVibrationRatings && alert.equipmentPartVibrationRatings.length > 0) {
          alertDtl += (alert.alertDtl ? newLine : "");
          alert.equipmentPartVibrationRatings.map(function(codes, idx) {
              alertDtl += codes.equipmentPart?.componentLocation?.name+' - '+codes.equipmentPart?.masterEquipmentPart?.name+' : ';
              alertDtl += codes.rank+newLine;
          })
      }
      return alertDtl;
  
    case "IOT_MNG":
      if (alert.iotDeviceDeadHistories?.length > 0) {
        const iotDeviceDeadHistories = groupAndDeduplicate(alert.iotDeviceDeadHistories, {groupBy : ["device"], dedupeBy: []})
        if (iotDeviceDeadHistories) {
          alertDtl += (alert.alertDtl ? newLine : "");
          iotDeviceDeadHistories.map(function(iotMng, idx) {
              // alertDtl += codes.equipmentPart?.componentLocation?.name+' - '+codes.equipmentPart?.masterEquipmentPart?.name+' : ';
              // alertDtl += codes.rank+'<br />';
              if (iotMng.group.device === 'SENSOR') {
                alertDtl += getEnumValueByEnumNameAndCode("AlertDevice",iotMng.group.device)?.[0]?.title + ' : '; 
                iotMng.items.map((item, idx2)=>{
                  alertDtl += (idx2 > 0 ? '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' : '');
                  alertDtl += (item.sn +'('+item.sensorPosition?.equipmentPart?.componentLocation?.name + ' - ' + item.sensorPosition?.equipmentPart?.masterEquipmentPart?.name + ')'+newLine);
                })
              }
              if (iotMng.group.device === 'GATEWAY') {
                alertDtl += getEnumValueByEnumNameAndCode("AlertDevice",iotMng.group.device)?.[0]?.title + ' : '; 
                iotMng.items.map((item, idx2)=>{
                  alertDtl += (idx2 > 0 ? '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' : '');
                  alertDtl += (item.sn + newLine);
                })
              }
          })
          return alertDtl;
        } else {
          return "";
        }
      } else {
        return "";
      }
    default:
      return "";
  }
}

export const makeFaultsMessage3 = (alert, getEnumValueByEnumNameAndCode, playMovie) => {
  switch (alert.alertCategory) {
    case "IOT_FD":
      return alert.equipmentPartFaultCodes && alert.equipmentPartFaultCodes.length > 0 ?
        alert.equipmentPartFaultCodes.map(function(codes, idx) {
          // console.log(codes.equipmentPart?.masterEquipmentPart?.code, codes.equipmentPart?.componentLocation?.code, codes.diagnosisCode?.code)
          return (
      <div key={idx}>
          <Link to={`/equipment-alert-history-tracking/${alert.id}`} style={{color:"#fff"}}>{codes.equipmentPart?.componentLocation?.name} - {codes.equipmentPart?.masterEquipmentPart?.name} : 
          {codes.diagnosisCode?.subCategoryNm}({codes.diagnosisCode?.categoryNm})</Link>
          {playMovie && <>&nbsp;<span className="icon_png" style={{verticalAlign:"middle", cursor:"pointer"}} 
            onClick={()=>{playMovie(codes.equipmentPart?.masterEquipmentPart?.code, codes.equipmentPart?.componentLocation?.code, codes.diagnosisCode?.code)}}>
            <img src={`${process.env.PUBLIC_URL}/img/icon/emergency_recording.png`} alt='' />
          </span><br /></>}
      </div> 
          )
        })
      : ""
  
    case "IOT_VK":
      return alert.equipmentPartVibrationRatings && alert.equipmentPartVibrationRatings.length > 0 ?
        alert.equipmentPartVibrationRatings.map(function(codes, idx) {
          return (
      <div key={idx}>
          {codes.equipmentPart?.componentLocation?.name} - {codes.equipmentPart?.masterEquipmentPart?.name} : 
          {codes.rank}<br />
      </div> 
          )
        })
      : ""
  
    case "IOT_MNG":
      if (alert.iotDeviceDeadHistories?.length > 0) {
        const iotDeviceDeadHistories = groupAndDeduplicate(alert.iotDeviceDeadHistories, {groupBy : ["device"], dedupeBy: []})
        if (iotDeviceDeadHistories) {
          return iotDeviceDeadHistories.map((iotMng, idx) => {
            if (iotMng.group.device === 'SENSOR') {
              return (
                <div key={idx}>{getEnumValueByEnumNameAndCode("AlertDevice",iotMng.group.device)?.[0]?.title+" : "}
                {iotMng.items.map((item, idx2)=>{
                  return (
                    <React.Fragment key={idx2}>
                    {idx2 > 0 && <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                    {item.sn} ({item.sensorPosition?.equipmentPart?.componentLocation?.name} - {item.sensorPosition?.equipmentPart?.masterEquipmentPart?.name})<br/>
                    </React.Fragment>
                  )
                })}
                </div>
              )
            }
            if (iotMng.group.device === 'GATEWAY') {
              return (
                <div key={idx} style={{display:"flex", alignItems:"center"}}>{getEnumValueByEnumNameAndCode("AlertDevice",iotMng.group.device)?.[0]?.title+" : "}
                {iotMng.items.map((item, idx2)=>{
                  return (
                    <React.Fragment key={idx2}>
                    {idx2 > 0 && <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                    {item.sn}<br />
                    </React.Fragment>
                  )
                })}
                </div>
              )
            }
          })
        } else {
          return "";
        }
      } else {
        return "";
      }
    default:
      return "";
  }
}

/* ===============================
  IAQ 상태 계산
=============================== */
export const iaqStatusRangeInfo = (v,) => {
  if (v > 85) return {name:"message.common.text.very.good",color: statusColor(v)}
  if (v > 70) return {name:"message.common.text.well",color: statusColor(v)}
  if (v > 55) return {name:"message.common.text.average",color: statusColor(v)}
  return {name:"message.common.text.bad",color: statusColor(v)}
};

export const statusColor = (v) => {
  if (v > 85) return "#2ecc71";
  if (v > 70) return "#a3d977";
  if (v > 55) return "#f1c40f";
  return "#e74c3c";
};

export const colors = [
  ['#37A2FF', '#6CFFB3'],
  ['#FF6B6B', '#FFD93D'],
  ['#845EC2', '#D65DB1'],
  ['#00C9A7', '#92FE9D']
];


export function flattenMenus(menu, result = []) {
    if (!menu) return result;
    if (menu.children?.length === 0) {
        result.push(menu);
    }
    if (menu.children?.length) {
    menu.children.forEach(child => {
        flattenMenus(child, result);
    });
    }

    return result;
}

const normalizePath = (path) => {

    if (!path) {
        return '/';
    }

    const normalized = path
        .replace(/^\/+/, '')
        .replace(/\/+$/, '');

    return normalized
        ? '/' + normalized
        : '/';
};

export const findMenuByFullPath = (
    menus,
    pathname
) => {
    const normalizedPath = normalizePath(pathname);
    let matchedMenu = null;

    for (const menu of menus || []) {

        const menuPath = normalizePath(menu.fullpath);

        // 정확히 일치
        if (normalizedPath === menuPath) {
            matchedMenu = menu;
            continue;
        }

        // 메뉴의 하위 URL인지 확인
        // 예:
        // /setting/iot/sensor/123
        //          ↓
        // /setting/iot/sensor
        if (
            normalizedPath.startsWith(
                menuPath + '/'
            )
        ) {
            if (
                !matchedMenu ||
                menuPath.length >
                    normalizePath(
                        matchedMenu.fullpath
                    ).length
            ) {
                matchedMenu = menu;
            }
        }
    }

    return matchedMenu;
};

// export const resizeFile = (file, maxWidth, maxHeight) =>
//   new Promise((res) => {
//       Resizer.imageFileResizer(
//           file, // target file
//           maxWidth, // maxWidth
//           maxHeight, // maxHeight
//           "JPEG", // compressFormat : Can be either JPEG, PNG or WEBP.
//           90, // quality : 0 and 100. Used for the JPEG compression
//           0, // rotation
//           (uri) => res(uri), // responseUriFunc
//           "file" // outputType : Can be either base64, blob or file.(Default type is base64)
//           ,0,0	
//       );
//   }
// );